export enum StatusScreenTypeEnum {
  'SUCCESS' = 'SUCCESS',
  'PENDING' = 'PENDING',
  'APP_SWITCH' = 'APP_SWITCH',
  'WARNING' = 'WARNING',
  'FAILED' = 'FAILED'
}
